<template>
  <div>
    <div class="contents tournament">
      <table class="table board">
        <thead>
          <tr>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.number") }}
            </th>
            <th class="col-auto">{{ $t("title.common.location") }}</th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.owner") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.address") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.phone") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.status") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.control") }}
            </th>
            <th class="th-arrow"></th>
          </tr>
        </thead>
        <tbody v-if="data_yn">
          <template v-for="(item, index) in tournamentlocation">
            <tr class="btn1" @click="toggle_tr(index)" :key="index + 'l1'">
              <td class="col-auto d-none d-lg-table-cell">{{ item.no }}</td>
              <td class="col-auto">{{ item.shopname }}</td>
              <td class="col-auto d-none d-lg-table-cell">{{ item.name }}</td>
              <td class="col-auto d-none d-lg-table-cell">
                {{ item.address }}
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                {{ item.phone ? item.phone : "-" }}
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                {{ $t("title.tournament.participant") }}
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                <button
                  type="button"
                  class="btn btn-outline btn-xs"
                  @click="admintournamentshopdrop(item.shopno)"
                >
                  {{ $t("button.common.cancel") }}
                </button>
              </td>
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="col-auto d-lg-none d-md-tabel-cell"
              :class="{ show: view_hide === index }"
              :key="index + 'r1'"
              v-if="view_hide === index"
            >
              <td class="text-start" colspan="8">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.number") }}</div>
                    <div class="col-6">{{ item.no }}</div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.owner") }}</div>
                    <div class="col-6">{{ item.name }}</div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.address") }}</div>
                    <div class="col-6">{{ item.address }}</div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.phone") }}</div>
                    <div class="col-6">
                      {{ item.phone ? item.phone : "-" }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.control") }}</div>
                    <div class="col-6">
                      <button
                        type="button"
                        class="btn btn-outline btn-xs"
                        @click="admintournamentshopdrop(item.shopno)"
                      >
                        {{ $t("title.common.control") }}
                      </button>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="8" class="text-center">{{ $t("text.common.no_data") }}</td>
          </tr>
        </tbody>
      </table>
      <b-form @submit="onModalSubmit">
        <div class="filter-box-2 mt-5">
          <div>
            <select class="form-select-lg" v-model="searchData.searchtype">
              <option value="1">{{ $t("filter.common.location") }}</option>
              <option value="2">{{ $t("filter.common.shop_name") }}</option>
            </select>
          </div>
          <div class="search-input">
            <input
              type="text"
              class="form-control-lg"
              v-model="searchData.searchname"
            />
            <input
              class="btn btn-primary btn-lg search"
              type="submit"
              value=""
            />
          </div>
        </div>
      </b-form>
      <table class="table board">
        <thead>
          <tr>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.number") }}
            </th>
            <th class="col-auto">{{ $t("title.common.location") }}</th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.owner") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.address") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.phone") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.control") }}
            </th>
            <th class="th-arrow"></th>
          </tr>
        </thead>
        <tbody v-if="data_yn2">
          <template v-for="(item, index) in items">
            <tr class="btn1" @click="toggle_tr2(index)" :key="index + 'l2'">
              <td class="col-auto d-none d-lg-table-cell">{{ item.no }}</td>
              <td class="col-auto">{{ item.shopname }}</td>
              <td class="col-auto d-none d-lg-table-cell">{{ item.name }}</td>
              <td class="col-auto d-none d-lg-table-cell">
                {{ item.address }}
              </td>
              <td class="col-auto d-none d-lg-table-cell">{{ item.phone }}</td>
              <td class="col-auto d-none d-lg-table-cell">
                <button
                  type="button"
                  class="btn btn-outline btn-xs"
                  @click="admintournamentshopapply(item.shopno, item.shopname)"
                >
                  {{ $t("button.common.apply") }}
                </button>
              </td>
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide2 === index }"
                />
              </td>
            </tr>
            <tr
              class="col-auto d-lg-none d-md-tabel-cell"
              :class="{ show: view_hide2 === index }"
              :key="index + 'r2'"
              v-if="view_hide2 === index"
            >
              <td class="text-start" colspan="6">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.number") }}</div>
                    <div class="col-6">{{ item.no }}</div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.owner") }}</div>
                    <div class="col-6">{{ item.name }}</div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.address") }}</div>
                    <div class="col-6">{{ item.address }}</div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.phone") }}</div>
                    <div class="col-6">{{ item.phone }}</div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.control") }}</div>
                    <div class="col-6">
                      <button
                        type="button"
                        class="btn btn-outline btn-xs"
                        @click="
                          admintournamentshopapply(item.shopno, item.shopname)
                        "
                      >
                        {{ $t("button.common.apply") }}
                      </button>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="6">{{ $t("text.common.no_data") }}</td>
          </tr>
        </tbody>
      </table>
      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="page_total"
        v-model="searchData.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <a class="page-link" v-if="active">{{ page }}</a>
          <a class="page-link" v-else>{{ page }}</a>
        </template>
      </b-pagination-nav>
      <div class="row regis-btn">
        <div class="col-lg-6 alone">
          <button
            class="btn btn-outline-primary btn-xl"
            type="button"
            @click="$router.push({ name: 'TournamentList' }).catch(() => {})"
          >
            {{ $t("button.common.list") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ax from "@/api/tournament";

export default {
  name: "TournamentLocations",
  data() {
    return {
      tournamentno: this.$route.params.tournamentno || 0,
      searchData: {
        searchtype: this.$store.state.searchData.searchtype || 1,
        searchname: this.$store.state.searchData.searchname || "",
        pageno: this.$store.state.searchData.pageno || 1,
      },
      page_total: 1,
      total_cnt: 0,
      shop_cnt: 0,
      data_yn: true,
      data_yn2: true,
      rows: 10,
      items: [],
      tournamentlocation: [],
      view_hide: null,
      view_hide2: null,
    };
  },
  methods: {
    get_admintournamentshoplist() {
      ax.get_admintournamentshoplist(
        this.tournamentno,
        this.searchData,
        (flag, data) => {
          if (flag) {
            if (data.shoplistcnt <= 0) {
              this.data_yn2 = false;
              return false;
            } else {
              this.data_yn2 = true;
            }
            this.total_cnt = data.shoplistcnt;
            // alert(this.total_cnt);
            this.page_total = Math.ceil(data.shoplistcnt / this.rows);
            this.items = data.shoplist;
            this.shop_cnt = data.tournamentshoplistcnt;
            // alert(data.tournamentshoplistcnt);
            if (data.tournamentshoplistcnt <= 0) {
              this.data_yn = false;
              return false;
            } else {
              this.data_yn = true;
            }
            this.tournamentlocation = data.tournamentshoplist;
          } else {
            this.data_yn = false;
            this.data_yn2 = false;
            this.page_total = 0;
            alert(data);
          }
        }
      );
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
    toggle_tr2(index) {
      if (this.view_hide2 === index) this.view_hide2 = null;
      else this.view_hide2 = index;
    },
    onModalSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
      this.$router
        .push({
          query: {
            searchname: this.searchData.searchname,
            searchtype: this.searchData.searchtype,
          },
        })
        .catch(() => {});
    },
    linkGen(pageNum) {
      return pageNum === 1
        ? `?searchname=${this.searchData.searchname}&searchtype=${this.searchData.searchtype}`
        : `?page=${pageNum}&searchname=${this.searchData.searchname}&searchtype=${this.searchData.searchtype}`;
    },
    admintournamentshopapply(shopno, shopname) {
      // if (this.shop_cnt < 1) {
      // alert(this.shop_cnt);
      ax.set_admintournamentshopapply(
        this.tournamentno,
        shopno,
        (flag, data) => {
          if (flag) {
            this.get_admintournamentshoplist();
          } else {
            this.$notify({
              group: "alert",
              type: "warn",
              title: "Notice",
              text: data,
            });
            return false;
          }
        }
      );
      // } else {
      //   alert("Only one Locatoin can be selected.");
      //   return false;
      // }
    },
    admintournamentshopdrop(shopno) {
      if (this.shop_cnt > 1) {
        // alert(this.shop_cnt);
        ax.set_admintournamentshopdrop(
          this.tournamentno,
          shopno,
          (flag, data) => {
            if (flag) {
              this.get_admintournamentshoplist();
            } else {
              this.$notify({
                group: "alert",
                type: "warn",
                title: "Notice",
                text: data,
              });
              return false;
            }
          }
        );
      } else {
        alert(this.$i18n.t("alert.tournament.one_locatoin_selected"));
        return false;
      }
    },
  },
  watch: {
    "$route.query": function () {
      this.searchData.pageno = parseInt(this.$route.query.page) || 1;
      this.get_admintournamentshoplist();
    },
    searchData: {
      handler: function (val, oldVal) {
        this.$store.commit("setSearchData", val);
      },
      deep: true,
    },
  },
  mounted() {
    this.get_admintournamentshoplist();
  },
};
</script>

<style></style>
